import { Text } from "../../components";
import { useApp } from "../../hooks";
import { Tools } from "../../utils";

const LegalPage = ({ children }: { children: any }) => <Text>{children}</Text>;

export const Terms = () => (
  <LegalPage>
    By placing an order you agree that prices, tax, delivery fees, and discounts
    are calculated by the restaurant at checkout. Menu items may become
    unavailable. Orders can be cancelled by the kitchen when necessary.
  </LegalPage>
);

export const Privacy = () => (
  <LegalPage>
    We collect your name, phone number, and delivery details to fulfill your
    order. We do not sell your data. Contact the restaurant if you want an order
    removed from this device’s history.
  </LegalPage>
);

export const Refund = () => {
  const { bootstrap } = useApp();
  const phone = Tools.asText(
    bootstrap?.contact?.uanNumber || bootstrap?.contact?.whatsappNumber,
  );
  return (
    <LegalPage>
      {`Refunds and order issues are handled by phone or WhatsApp${
        phone ? ` at ${phone}` : ""
      }. There is no in-app voucher flow.`}
    </LegalPage>
  );
};
